$$.Pswp = function (context) {
    
    var Gallery;
    var $pswp = $('[js-pswp]').eq(0);

    if ( !$pswp.length ) {
        $pswp = $('<div js-pswp class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Закрыть (Esc)"></button><button class="pswp__button pswp__button--fs" title="На весь экран"></button><button class="pswp__button pswp__button--zoom" title="Масштаб"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Назад"></button><button class="pswp__button pswp__button--arrow--right" title="Вперёд"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>').appendTo($$.$body);
    }

    var $items = $('[js-pswp-item]', context);
    if ( !$items.length ) return;

    var photos = [];

    $items.each(function (i, item) {
        var $item = $items.eq(i);
        if ( !$item.attr('href').length ) {
            $item.removeData('pswp-index');
            return;
        }

        var data = {};
        var size = $item.data('size');

        data.src = $item.attr('href');
        if ( size ) {
            data.w = size.split('x')[0];
            data.h = size.split('x')[1];
            photos.push(data);
        }
        else {
            var $img = $item.children('img');
            if ( !$img.length ) return;

            $img.imagesLoaded().done(function( instance ) {
                data.w = $img[0].naturalWidth;
                data.h = $img[0].naturalHeight;
                photos.splice(i, 0, data);
            });
        }

        $item.data('pswp-index', i);
    });

    $items.off('.pswp').on({
        'click.pswp': function (e) {
            e.preventDefault();
            var index = $(this).data('pswp-index');
            if ( typeof index == 'undefined' ) return;

            Gallery = new PhotoSwipe( $pswp[0], PhotoSwipeUI_Default, photos, {
                // getThumbBoundsFn: function(index) {
                //     var thumbnail = $items.eq(index).find('.article-gallery__image')[0];
                //     var pageYScroll = window.pageYOffset;
                //     var rect = thumbnail.getBoundingClientRect();
                //     return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                // },
                history: false,
                closeOnScroll: false,
                loop: false,
                bgOpacity: .7,
                index: index
            });
            Gallery.init();
        }
    });
};
